<div
  #mapcontainer
  id="mapcontainer"
  class="mapcontainer"
  (keydown.esc)="fullscreenControl.isToggled$.next(false)"
  tabindex="0"
>
  <div id="map" class="map"></div>
  <div class="map-overlay map-overlay-top">
    <ng-content select="[map-overlay-top]"></ng-content>
  </div>
  <div class="map-overlay map-overlay-bottom">
    <ng-content select="[map-overlay-bottom]"></ng-content>
  </div>
  <div class="row justify-content-end">
    <div class="col col-auto pt-2">
      <a href="#" class="function-link pl-2" (click)="onHelpClick(true)">
        Hjælp<svg class="icon-svg icon-help-circle-outline ml-2"></svg>
      </a>
    </div>
  </div>
</div>

<bom-modal title="{{ 'MapHelpModal.Title' | tekstresource }}" [isOpen$]="isHelpModalOpen$">
  <ng-container bom-modal-header>
    <bom-save-indicator></bom-save-indicator>
  </ng-container>
  <ng-container bom-modal-content *ngFor="let helpSection of helpSections">
    <h2 class="mb-0">{{ helpSection.header }}</h2>
    <div *ngIf="helpSection.icon" class="map-help-section">
      <div class="map-help-icon {{ helpSection.icon }}"></div>
      <b>{{ helpSection.IconText }}</b>
    </div>
    <p class="mt-0">{{ helpSection.text }}</p>
  </ng-container>
</bom-modal>

<div *ngIf="enableMeasurement" #measurementTooltipElement class="tooltip tooltip-measurement">
  {{ measurementLength }}
</div>
